import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {SubscriptionStore} from "@intelingu/core/stores/SubscriptionStore";
import {lazyInject} from "@intelingu/core/IoC/container";

interface HelpPageProps {
}

@observer export class HelpPage extends Component<HelpPageProps, any> {

    @lazyInject(SubscriptionStore) subscriptionStore: SubscriptionStore;

    get hasActiveSubscriptions() {
        return this.subscriptionStore.subscriptions.filter(s => !s.is_expired && !s.is_trial).length > 0;
    }

    render() {
        return <div className={'static-page'} style={{ justifyContent: 'flex-start' }}>
            { this.hasActiveSubscriptions ? (
                <div>
                    <h2 className={'mt-3'}>Gerne stehen wir dir für Fragen rund um Intelingu zur Verfügung</h2><br />

                    <p>Du kannst uns unter der folgenden eMail-Adresse erreichen:</p>

                    <p><a href={'mailto:mitglied@intelingu.com'}>mitglied@intelingu.com</a></p>

                    <p>Wir versuchen unser Bestes, dir innerhalb von 24 Stunden auf deine Anfrage zu antworten.</p>
                </div>
            ) : (
                <div>
                    <h2 className={'mt-3'}>Fragen rund um Intelingu?</h2><br />

                    <p>Bitte habe Verständnis dafür, dass wir nur zahlenden Mitgliedern auf spezifische Fragen rund um unser Sprachlern-System antworten können. </p>

                    <p>Solltest du Fragen zur oder Probleme mit dem Bestellprozess haben, so kannst du uns unter der folgenden E-Mail Adresse erreichen:</p>

                    <p><a href={'mailto:info@intelingu.com'}>info@intelingu.com</a></p>
                </div>
            ) }
        </div>
    }

}
